var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal_size notice_size" }, [
    _c(
      "a",
      {
        staticClass: "ui_close",
        attrs: { href: "javascript:", type: "button" },
        on: { click: _vm.closePopup }
      },
      [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
    ),
    _vm._v(" "),
    _c("dl", { staticClass: "modal_content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("dd", [
        _vm._m(1),
        _vm._v(" "),
        _vm.mode === "alert"
          ? _c("div", { staticClass: "today_wrap" }, [
              _c("div", { staticClass: "item_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "txt_link",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.closePopup()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("FIELD.GLOBAL.ETC.083")) +
                        "\n                    "
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "notice ellipsis" }, [
      _c("i", [_vm._v("IT VOC")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "notice_view" }, [
      _c("dt", [_vm._v("Please contact Help Desk in case of any issue.")]),
      _vm._v(" "),
      _c("dd", [
        _vm._v("\n                    SKP Helpdesk ("),
        _c(
          "a",
          { attrs: { href: "mailto:skp.sec@samsung.com", target: "_blank" } },
          [_vm._v("skp.sec@samsung.com")]
        ),
        _vm._v(") : 24Hr help desk [8/4(Tue) ~ 8/8(Sat) 08:00]"),
        _c("br"),
        _vm._v("\n                    Seunghyun(Chris) You ("),
        _c(
          "a",
          { attrs: { href: "mailto:sh77.you@samsung.com", target: "_blank" } },
          [_vm._v("sh77.you@samsung.com")]
        ),
        _vm._v(")"),
        _c("br"),
        _vm._v("\n                    Ray Myongsoek Shin ("),
        _c(
          "a",
          { attrs: { href: "mailto:ray.shin@samsung.com", target: "_blank" } },
          [_vm._v("ray.shin@samsung.com")]
        ),
        _vm._v(")"),
        _c("br")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba0ee986", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba0ee986","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/main/ITVocViewPopup.vue
// module id = HL8q
// module chunks = 0